function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTdBank = function SvgTdBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57b14c"
    },
    d: "M0 0h40v26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.965 19.37H18.18V9.1h2.86v8.45h2.86c1.95 0 2.73-1.365 2.73-4.68 0-3.445-.91-4.42-2.86-4.42H17.4v10.985h-2.86V8.45h-4.29V6.63h14.365c3.51 0 5.135 1.755 5.135 6.175 0 5.915-2.47 6.565-5.785 6.565",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgTdBank;